
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components_root/loading";
import Loadingimg from '../components_root/loadingimg';
import { googleLogout, checkUserAuth } from '../firebase';
import ShareButton from '../components_root/ShareButton';
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './favicon.css';
import { MdDownload } from 'react-icons/md';
export const seo = {
    title: "Free Favicon Generator Online | Create Website Icons Easily",
    description: "Generate favicons online for free. Upload your image, choose from 16x16, 32x32, 48x48 sizes, and download in .ico format. Works for websites, apps, and browsers.",
    keywords: "favicon generator, free favicon, create favicon, favicon online, website icon maker, favicon converter, png to ico, favicon sizes",
    url: "https://yourwebsite.com/favicon-generator",
    image: "https://yourwebsite.com/assets/favicon-preview.png"
};
export default function FaviconGenerator() {
    const [image, setImage] = useState(null);
    const [size, setSize] = useState(32);

    // Handle file upload (drag & drop or input)
    const handleFile = (file) => {
        if (file && file.type.startsWith("image")) {
            const reader = new FileReader();
            reader.onload = (e) => setImage(e.target.result);
            reader.readAsDataURL(file);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length > 0) {
            handleFile(e.dataTransfer.files[0]);
        }
    };

    const handleDownload = () => {
        if (!image) return;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
            canvas.width = size;
            canvas.height = size;
            ctx.drawImage(img, 0, 0, size, size);

            // Download as ICO (using PNG data but with .ico extension)
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = "favicon.ico";
            link.click();
        };
        img.src = image;
    };

    return (
        <div >
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
                <meta name="twitter:image" content="https://viabig.com/og-image.png" />
                <meta property="og:image" content="https://viabig.com/logo.png" />
                <meta property="og:url" content="https://viabig.com/tools/favicon-generator" />
            </Helmet>

            <div className='container_roots'>
                <div className='container_size p-3'>
                    <h2 className="text-xl font-bold mb-4">Free Favicon Generator</h2>

                    {/* Drag and Drop Zone */}
                    <div className="Drag_Drop-body rounded"

                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                    >
                        {image ? (
                            <>
                                <img
                                    src={image}
                                    alt="preview"
                                    className="preview"
                                />

                            </>

                        ) : (
                            <div className="Drag_Drop text-h2">


                                <label htmlFor="uploadImage" className="select-text text-h1 cursor">
                                    Drag & Drop Image or Click to Upload
                                </label>
                                <input
                                    id="uploadImage"
                                    type="file"
                                    accept="image/*"
                                    className="select_photo"
                                    onChange={(e) => handleFile(e.target.files[0])}
                                />
                            </div>
                        )}
                        <br />
                        {image ? (
                            <>
                                <label htmlFor="uploadImage" className="select-text text-h1 cursor">
                                    Change Image
                                </label>
                                <input
                                    id="uploadImage"
                                    type="file"
                                    accept="image/*"
                                    className="select_photo"
                                    onChange={(e) => handleFile(e.target.files[0])}
                                />
                            </>) : (
                            <></>
                        )}
                    </div>
                    <br />
                    {/* Size Selector */}
                    {image ? (
                        <>

                            <div>


                                <div className='post-container'>
                                    <div className='post_div '>
                                        <div className="ui-grid-100">
                                            {[16, 32, 48, 64, 128].map((s) => (
                                                <div
                                                    key={s}
                                                    className={`ui-items items-back-fill p-3 center  text-h2 bold border cursor rounded-md ${size === s ? "blue-back text-white" : ""
                                                        }`}
                                                    onClick={() => setSize(s)}
                                                >
                                                    {s}x{s}
                                                </div>
                                            ))}
                                        </div>
                                  
                                    </div>
                                    {/* Download Button */}
                                    <br />
                                </div>
                                <br />
                                <div
                                    onClick={handleDownload}
                                    disabled={!image}
                                    className="button-ui fill p-33"
                                ><MdDownload className='icon' />
                                    Download .ico
                                </div>
                            </div>
                        </>

                    ) : (
                        <div className="description text-h2">Easily create a favicon for your website in just a few steps.<br /> Upload or drag & drop your image, choose the size (16x16, 32x32, 48x48, etc.), and generate your favicon in .ico format.</div>
                    )}
                </div>
            </div>
            <Footers />
            <Navbar />
        </div>
    );
}
